<script lang="ts" setup>
import BaseTag from './BaseTag.vue';

defineProps<{
  amosCode: string;
}>();
</script>

<template>
  <BaseTag rounded-3xl>
    {{ amosCode }}
  </BaseTag>
</template>
